import { useCallback } from "react";
import { usePostDocumentGenarateMutation } from "@api/documents";
import { PersonaStructure } from "@interfaces/response";

/**
 * Hook para generar el documento anexo_1 si la persona cumple con los requisitos necesarios.
 * @returns Función para generar el anexo_1 o anexo_2
 *
 * @example
 * const generateAnexo1 = useGenerateAnexo();
 * const success = await generateAnexo1(loanApplicationId, person, "anexo_1");
 */
const useGenerateAnexo = () => {
  const [createDocAnexo1] = usePostDocumentGenarateMutation();

  const generateAnexo1 = useCallback(
    async (
      loanApplicationId: string,
      person: PersonaStructure,
      document_type: "anexo_1" | "anexo_2",
    ): Promise<boolean> => {
      try {
        const { personal_information_status: info_status, bank_references_status: bank_status } = person;

        if (info_status === "COMPLETO" && bank_status === "COMPLETO") {
          const payload_anexo_1 = {
            loan_application_id: loanApplicationId,
            document_type,
            person_id: person.id,
          };

          await createDocAnexo1(payload_anexo_1).unwrap();
          return true;
        }

        return false;
      } catch (error) {
        return false;
      }
    },
    [createDocAnexo1],
  );

  return generateAnexo1;
};

export default useGenerateAnexo;
